"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObject_1 = require("../AnimationObject");
var MarkerType;
(function (MarkerType) {
    MarkerType["None"] = "none";
    MarkerType["Poster"] = "poster";
    MarkerType["Snapshot"] = "snapshot";
})(MarkerType = exports.MarkerType || (exports.MarkerType = {}));
var Marker = (function (_super) {
    tslib_1.__extends(Marker, _super);
    function Marker(config, rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        _this.config = config;
        return _this;
    }
    Object.defineProperty(Marker.prototype, "startFrame", {
        get: function () {
            return this._rawData.tm;
        },
        set: function (frame) {
            this._rawData.tm = frame;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Marker.prototype, "durationInFrames", {
        get: function () {
            return this._rawData.dr;
        },
        set: function (frames) {
            this._rawData.dr = frames;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Marker.prototype, "comment", {
        get: function () {
            return this._rawData.cm;
        },
        set: function (comment) {
            this._rawData.cm = comment;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Marker.prototype, "type", {
        get: function () {
            return this.config.t;
        },
        enumerable: true,
        configurable: true
    });
    Marker.prototype.toJSON = function () {
        return {
            type: this.type,
            startFrame: this.startFrame,
            durationInFrames: this.durationInFrames,
            comment: this.comment,
            config: this.config
        };
    };
    return Marker;
}(AnimationObject_1.AnimationObject));
exports.Marker = Marker;
//# sourceMappingURL=Marker.js.map